import { useContext } from "react";

import { MobileDrawerContext } from "../providers/types";

export const useMobileDrawer = () => {
  const context = useContext(MobileDrawerContext);
  if (!context) {
    throw new Error(
      "useMobileDrawer must be used within a MobileDrawerProvider"
    );
  }
  return context;
};
